import React from 'react';
import { useSelector } from 'react-redux';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { PLP_PAGE } from 'common/constants/SharedConstants';
import { getAndCheck } from 'common/utilities/utils';
import { ButtonType, ContainedButton } from '../../../atoms/Buttons';
import { SetLocationBanner } from 'organisms/SetLocationBanner';

export const PromosBanner = props => {
  const { setLocationClickHandler, page } = props;
  const { SEE_PROMOS_FOR_YOU, SET_LOCATION } = TRANSLATE_MAPPING_KEY;
  const setLocationData = { buttonText: translateWithI18Next(SET_LOCATION) };
  const { tenantReducer } = useSelector(data => data);
  const enableAutoSetLocation = tenantReducer?.componentOptions?.web?.dispositionConfig?.enableAutoSetLocation;

  return (
    <div id='startorder-container' data-testid='set-locaton-component'>
      <div
        data-testid='start-order-items'
        className={`sc-dlnjwi redBg headerBottom ${getAndCheck(page === PLP_PAGE, 'plp-headBottom')}`}
        id='start-order-component'
      >
        <div className='headBottomParent'>
          <div className={`headBottomTxt ${getAndCheck(page === PLP_PAGE, 'plp-headBottomTxt')}`}>
            {translateWithI18Next(SEE_PROMOS_FOR_YOU)}
          </div>
          {!enableAutoSetLocation ? (
            <ContainedButton
              onClick={() => setLocationClickHandler()}
              variant={ButtonType.secondary}
              inverted
              role='button'
              aria-label='Start Order'
              data-testid='set-location-buttonId'
              id='startOrderItemButton'
              type='button'
            >
              <span>{translateWithI18Next(SET_LOCATION)}</span>
            </ContainedButton>
          ) : (
            <SetLocationBanner setLocationdata={setLocationData} />
          )}
        </div>
      </div>
    </div>
  );
};

export default PromosBanner;
